/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/user.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.User,
 *   !proto.fitness.service.v1.UserResponse>}
 */
const methodDescriptor_UserService_CreateUser = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.UserService/CreateUser',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.User,
  proto.fitness.service.v1.UserResponse,
  /**
   * @param {!proto.fitness.service.v1.User} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UserResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.User} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.UserServiceClient.prototype.createUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.User} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UserResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.UserServicePromiseClient.prototype.createUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UserRequest,
 *   !proto.fitness.service.v1.UserResponse>}
 */
const methodDescriptor_UserService_GetUser = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.UserService/GetUser',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UserRequest,
  proto.fitness.service.v1.UserResponse,
  /**
   * @param {!proto.fitness.service.v1.UserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UserResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.UserServiceClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.UserService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UserResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.UserServicePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.UserService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.User,
 *   !proto.fitness.service.v1.UserResponse>}
 */
const methodDescriptor_UserService_UpdateUser = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.UserService/UpdateUser',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.User,
  proto.fitness.service.v1.UserResponse,
  /**
   * @param {!proto.fitness.service.v1.User} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UserResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.User} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.UserServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.User} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UserResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.UserServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UserRequest,
 *   !proto.fitness.service.v1.UserResponse>}
 */
const methodDescriptor_UserService_DeleteUser = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.UserService/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UserRequest,
  proto.fitness.service.v1.UserResponse,
  /**
   * @param {!proto.fitness.service.v1.UserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UserResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.UserServiceClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UserResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.UserServicePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser);
};


module.exports = proto.fitness.service.v1;

